/* eslint-disable max-len */
const arAe = {
  CancellationRequest: 'طلب إلغاء',
  Heading: 'يرجى تقديم المعلومات التالية. جميع الحقول مطلوبة',
  Note: 'تحتاج إلى إلغاء حجزك؟ نحن هنا لمساعدتك. املأ الحقول أدناه فيما يتعلق بالحجز الذي تود إلغاءه.',
  PartnerNote:
    'شكرًا! نحن نرتب أولوية التعامل مع الطلبات حسب تاريخ السفر. إذا لم نقم بتأكيد إلغاء حجزك قبل تاريخ السفر، فاعلم أننا نعمل على طلبك. لا تحتاج إلى القيام بأي شيء آخر.',
  SubmitNote:
    'نظرًا لتعطّل أعداد هائلة من الرحلات بشكلٍ غير مسبوق، قد تحدث تأخيرات في رد المال. نعتذر عن أي تأخير ونُقدر سعة صدرك.',
  Disclaimer:
    'ملحوظة مهمة: استخدم هذا النموذج فقط إذا كانت تواريخ سفرك تقع في الفترة حتى 31 ديسمبر 2021.',
  Itin: 'رقم خط سير الرحلة (يتكون من 11 إلى 15 حرفًا، ويوجد في خط سير رحلتك أو رسالة التأكيد الإلكترونية المرسلة إليك)',
  EmailAddress: 'عنوان البريد الإلكتروني المستخدم في إجراء هذا الحجز',
  PhoneNumber: 'رقم الهاتف المستخدم في إجراء هذا الحجز',
  Reason: 'السبب',
  Submit: 'متابعة',
  Success: 'لقد تلقينا طلبك',
  Failed: 'عذرًا',
  InProgress: 'نحن نعمل على طلبك',
  TryAgain: 'عودة',
  PhoneErrorMessage: 'يُرجى إدخال رقم هاتف صالح',
  EmailErrorMessage: 'برجاء إدخال عنوان بريد إلكتروني صالح',
  ItinErrorMessage: 'برجاء إدخال رقم صالح',
  ResponseEligibleHeader: 'عثرنا على رحلتك',
  ResponseEligibleSubmit: 'نعم، قم بإلغاء حجوزاتي',
  ResponseEligibleNeverMind: 'لا، لا تلغي الحجوزات',
  ResponseOnlyLodgingWithRefund:
    'لديك حجوزات إقامات مؤهلة لاسترداد المال، وعددها {x}. إذا اخترت إلغاء هذه الحجوزات، سيتم رد الأموال إلى طريقة السداد الأصلية.',
  ResponseOnlyLodgingWithCoupon:
    'لديك حجوزات إقامة مؤهلة للحصول على قسيمة، وعددها {x}. إذا اخترت الإلغاء، سنصدر قسيمة بالمبلغ الأصلي للحجز.',
  ResponseOnlyLodgingInEligible:
    'لديك حجوزات إقامات غير مؤهلة للإلغاء المجاني، وعددها {x}. إذا اخترت الإلغاء، ستطبق سياسات الإلغاء المعتادة لشركائنا فيما يتعلق بأماكن الإقامة.',
  ResponseLodgingWithOtherLob:
    'بالنسبة لجميع الحجوزات الأخرى المرتبطة بخط سير هذه الرحلة، ستُطبق السياسات الخاصة بشركاء السفر لدينا.',
  ResponseNoLodgingWithOtherLob:
    'بالنسبة لجميع الحجوزات الأخرى المرتبطة بخط سير هذه الرحلة، ستُطبق السياسات الخاصة بشركاء السفر لدينا.',
  ResponseAlreadyCancelled:
    'لديك حجوزات تم إلغاؤها بالفعل، وعددها {x}. نظرًا لتعطّل أعداد هائلة من الرحلات بشكلٍ غير مسبوق، قد تحدث تأخيرات في رد المال. إذا كانت لديك أي استفسارات، يرجى التواصل مع دعم العملاء الخاص بنا.',
  ResponseNoFlexAvailable:
    'لديك حجوزات إقامة غير مؤهلة لاسترداد المال أو الحصول على قسيمة، وعددها {x}. إذا اخترت الإلغاء، ستطبق سياسات الإلغاء المعتادة لشركائنا فيما يتعلق بأماكن الإقامة. لكن من المُحتمَل أن تتغيّر سياسات الإلغاء. يمكنك المراجعة مجددا قبل بدء رحلتك بثمانية أيام للاطّلاع على أحدث سياسة إلغاء.',
  ResponseInvalidDuplicateItinerary:
    'يبدو أنك قد سبق وأرسلت هذا الطلب. نحن نرتب أولوية التعامل مع الطلبات حسب تاريخ السفر. إذا لم نقم بتأكيد إلغاء حجزك قبل تاريخ السفر، فاعلم أننا نعمل على طلبك. لا تحتاج إلى القيام بأي شيء آخر.',
  ResponseElligibleConfirmation: 'هل ترغب في إلغاء حجوزاتك؟',
  ResponseInvalidUnknown:
    'لا يمكننا العثور على رقم التأكيد أو رقم خط سير الرحلة. يُرجى التحقّق من الرقم والمحاولة مرّة أخرى. يمكنك العثور على الرقم في الرسالة الإلكترونية التي تلقيتها منا بعد إجراء حجزك أول مرة.',
  ResponseInvalidItineraryNotFound:
    'لا يمكننا العثور على رقم التأكيد أو رقم خط سير الرحلة. يُرجى التحقّق من الرقم والمحاولة مرّة أخرى. يمكنك العثور على الرقم في الرسالة الإلكترونية التي تلقيتها منا بعد إجراء حجزك أول مرة.',
  ResponseInvalidTripMoreThanSevenDays: 'لم نتمكن من التعامل مع طلبك.',
  ResponseInvalidTripIsLcc:
    "تقوم شركة الطيران بالتعامل مع جميع الإلغاءات. يرجى التواصل مع شركة الطيران مباشرة. لمزيد من المعلومات، يرجى تسجيل الدخول إلى حسابك ومراجعة خط سير رحلتك عبر الإنترنت. قد يستغرق الأمر حتى 72 ساعة حتى تظهر الإلغاءات التي يتم التعامل معها حاليًا في حالة 'ملغاة' في خط سير رحلتك.",
  ResponseInvalidTripIsTicketless:
    "تقوم شركة الطيران بالتعامل مع جميع الإلغاءات. يرجى التواصل مع شركة الطيران مباشرة. لمزيد من المعلومات، يرجى تسجيل الدخول إلى حسابك ومراجعة خط سير رحلتك عبر الإنترنت. قد يستغرق الأمر حتى 72 ساعة حتى تظهر الإلغاءات التي يتم التعامل معها حاليًا في حالة 'ملغاة' في خط سير رحلتك.",
  ResponseInvalidItinerary:
    'لم نتعرّف على رقم خط سير الرحلة المذكور. يُرجى إعادة المحاولة.',
  ResponseInvalidStatus: 'حدث خطأ ما. يُرجى إعادة المحاولة.',
  ResponseInvalidEmail:
    'لم نتعرف على هذا البريد الإلكتروني، أو أنه لا يتوافق مع البريد الإلكتروني المرتبط بخط سير الرحلة المذكور. يرجى التأكد من أن هذا هو عنوان البريد الإلكتروني الذي استخدمته عند الحجز.',
  ResponseInvalidPhone:
    'لا يمكننا التعرف على رقم خط سير الرحلة المذكور. يرجى التأكد من أن هذا هو الرقم الذي استخدمته عند الحجز.',
  ResponseTripHasLccFlight:
    "يمكننا إلغاء بعض من حجوزاتك، وليس كلها. بالنسبة للحجوزات التي لا يمكننا إلغاؤها، يرجى التواصل مع مقدم الخدمة مباشرة. يمكنك استخدام خط سير رحلتك عبر الإنترنت للعثور على الحجوزات التي لا تزال بحاجة للإلغاء. قد يستغرق الأمر حتى 72 ساعة حتى تظهر الإلغاءات التي يتم التعامل معها حاليًا في حالة 'ملغاة' في خط سير رحلتك.",
  ResponseErrorTripWithin24Hrs:
    'يتعذّر علينا التعامل مع إلغاء الحجز الخاص بك لأنه تبقى أقل من 24 ساعة على تاريخ تسجيل وصولك. لمزيد من المعلومات، يرجى تسجيل الدخول إلى حسابك ومراجعة خط سير رحلتك عبر الإنترنت.',
  ResponseInvalidTripInCruise:
    'لا يمكننا قبول طلبات الإلغاء الخاصة بالرحلات المائية باستخدام هذا النموذج. يرجى تسجيل الدخول إلى حسابك وإجراء الإلغاء من خط سير رحلتك عبر الإنترنت.',
};
export default arAe;
